import gql from 'graphql-tag';

export const getStationLogHistories = gql`
  query getStationLogHistories($id: String) {
    getStationLogHistories(id: $id) {
      updater
      updatedAt
    }
  }
`;
